import { useEffect } from 'react';
import {
  runDashboardDeviceCapabilityCheck,
  runDashboardNetworkQualityCheck
} from '../utils/dashboard/devicePerfHelpers';

/**
 * 设置加载完成后做一次设备性能 / 网络质量检测
 */
export default function useDashboardPerfInit({
  settingsLoaded,
  apiFetch,
  setDevicePerformance,
  setNetworkQuality,
  setRefreshInterval
}) {
  useEffect(() => {
    if (!settingsLoaded) {
      console.log('设置尚未加载完成，跳过性能检测初始化');
      return;
    }

    console.log('设置加载完成，开始性能检测...');
    runDashboardDeviceCapabilityCheck(setDevicePerformance);
    runDashboardNetworkQualityCheck({
      apiFetch,
      setNetworkQuality,
      setRefreshInterval
    });
    console.log('性能检测完成，避免重复刷新机制');
  }, [settingsLoaded]);
}
